import { render, staticRenderFns } from "./FieldEntityUserProfileRetailer.vue?vue&type=template&id=0195e0e2&"
import script from "./FieldEntityUserProfileRetailer.vue?vue&type=script&lang=js&"
export * from "./FieldEntityUserProfileRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports